import React from 'react';
import { FieldError } from 'react-hook-form';
import { useParams } from "react-router-dom";

import FormErrors from '../../../global/components/public/form-errors';

const errorMessage = (errcode) => {
    switch(errcode) {
        case '10' :
            return 'We were unable to process your request.';
        case '20' :
            return 'Your account can only be accessed through single sign on. Check with your organization.';
        case '30' :
            return 'There were too many password reset requests.';
        default:
            return 'There was a problem processing your request.';
    }
};

const Error: React.FC<{ mhqp: boolean }> = ({ mhqp = false }) => {

    const url = () => mhqp ? '/mhqppeslogin' : '/login';
    const { errcode } = useParams();

    return <div id={`forgot-password${mhqp ? '-mhqp' : ''}`}>
        <section className='pt-md-8 pb-md-4 pb-3 pt-8'>
            <div className='container mt-2 mt-md-5'>
                <div className='pt-lg-7 pb-lg-6'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-10 col-lg-7'>
                            <h2>The page encountered an error</h2>
                            <p>
                                <FormErrors 
                                    className='text-xs mt-1 pt-0 mb-2 text-light-danger' 
                                    error={({message: errorMessage(errcode)} as FieldError)} />
                            </p>
                            <p>
                                <a href={url()}>Return to login.</a>
                            </p>                            
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>;
};

export default Error;